
export abstract class TouchHandlerEvent extends Event {

}
